import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import styles from './EventDetails.module.postcss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/Los_Angeles');
import TruckTeaseBadges from '../TruckTeaseBadges';

function EventDetails({ event: { start_time, end_time }, address, showBadges = false, vehicleType, establishedYear, className }) {
  return (
    <div className={cn(styles.EventDetails, className)}>
      { address &&
        <div className={styles.EventDetails_Info}>
          <div><img src='/static/images/icons/pin.svg' alt='Address'/></div>
          <div>{address}</div>
        </div>
      }

      <div className={styles.EventDetails_Info}>
        <div><img src='/static/images/icons/cal.svg' alt='Event Date'/></div>
        <div>{dayjs(start_time).tz().format('dddd, MMMM Do')}</div>
      </div>

      <div className={styles.EventDetails_Info}>
        <div><img src='/static/images/icons/clock.svg' alt='Event Time'/></div>
        <div>{dayjs(start_time).tz().format('h:mma')} - {dayjs(end_time).tz().format('h:mma')}</div>
      </div>

      { showBadges &&
        <div className={styles.EventDetails_Badges}>
          <TruckTeaseBadges vehicleType={vehicleType} establishedYear={establishedYear} />
        </div>
      }
    </div>
  );
}

EventDetails.propTypes = {
  event: PropTypes.object.isRequired,
  address: PropTypes.string,
  showBadges: PropTypes.bool,
  vehicleType: PropTypes.string,
  establishedYear: PropTypes.string,
};

export default EventDetails;
